<script setup lang="ts">
import { useActivityDetailsPanelsStore } from '../stores';
import { ActivityDetailsPanelType } from '../models';

import TicketsSelectorPanel from './ticketsSelector/TicketsSelectorPanel.vue';

const activityDetailsPanelsStore = useActivityDetailsPanelsStore();

interface ActivityDetailsPanelsEmits {
  (event: 'select-tickets'): void;
}
const emit = defineEmits<ActivityDetailsPanelsEmits>();
</script>

<template>
  <TicketsSelectorPanel
    v-if="
      activityDetailsPanelsStore.activityDetailsPanelType ===
      ActivityDetailsPanelType.TicketsSelection
    "
    @close="activityDetailsPanelsStore.closePanel"
    @select-tickets="emit('select-tickets')"
  />
</template>
